import {
  Box,
  Flex,
  Button,
  Alert,
  AlertTitle,
  AlertDescription,
  Accordion,
} from "@chakra-ui/react";
import BoxHeader from "components/elements/BoxHeader";
import { LoanContext } from "providers/loan";
import { useContext, useEffect, useState } from "react";
import { apiRequest } from "utils/api";
import { stringToFullNumber } from "utils/helpers";
import Scenario from "../Scenario";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { isPermissionEnabled, permissionConstants, hasPermission } from "utils/permissionHelper";

const Scenarios = () => {
  const { loan } = useContext(LoanContext);
  const { user } = useTenant();

  const [scenarios, setScenarios] = useState<any[]>([]);
  const [readLoan, setReadLoan] = useState(false);

  useEffect(() => {
    setScenarios(loan?.scenarios ?? []);
  }, [loan]);

  const readOnlyLoan = () => {
    if (isPermissionEnabled(user) && hasPermission(user, permissionConstants.readOnlyLoans)) {
      setReadLoan(true);
    }
  };

  useEffect(() => {
    readOnlyLoan();
  }, []);

  const addScenario = async (template?: any) => {
    try {
      const response = await apiRequest("/supabase/scenarios/insert", {
        loan_id: loan!.id,
        params: template
          ? {
              ...template,
              id: undefined,
            }
          : {
              amount: stringToFullNumber(loan!.amount),
              loan_term: 10,
              interest_only: 5,
              amortization_months: 30,
              funding_date: loan!.funding_date,
              interest_rate_type: "Fixed",
              spread_bps: 200,
              interest_calculation: "30/360",
              benchmark: 330,
              fee: 1000,
            },
      });

      setScenarios([...scenarios, response.scenario]);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box>
      <Flex alignItems="center" justifyContent="space-between">
        <BoxHeader mb="0px" title="Scenario Modeling" />
        <Button variant="white" onClick={() => addScenario(null)} isDisabled={readLoan} size="sm">
          Create Scenario
        </Button>
      </Flex>

      {scenarios.length === 0 && (
        <Alert
          status="info"
          mt="20px"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          borderRadius="20px"
          height="200px"
        >
          <AlertTitle mt={4} mb={1} fontSize="lg">
            Underwriting Scenarios
          </AlertTitle>
          <AlertDescription maxWidth="sm">
            You can create underwriting scenarios based off of the current loan details.
          </AlertDescription>
        </Alert>
      )}

      <Accordion mt="20px" defaultIndex={[0]} allowMultiple={true}>
        {scenarios.map((scenario, index) => (
          <Scenario
            key={`scenario-${index + 1}`}
            initScenario={scenario}
            index={index}
            copyScenario={addScenario}
          />
        ))}
      </Accordion>
    </Box>
  );
};

export default Scenarios;
